import React, { useState, useEffect } from 'react';
import {
    Grid,
    Card,
    CardMedia,
    CardContent,
    Typography,
} from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import BackButton from '../BackButton';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';
import { withRouter } from 'react-router-dom';
import { styles } from './CampaignPromo.styles';
import { marketing } from '../../constants/mainViewList';
import { CAMPAIGN_ITEMS, CampaignItem, CAMPAIGN_WITHOUT_PRODUCT_SELECTION, SHOPS_MODAL_TEXT } from '../../constants/marketingCampaign';
import CampaignRestaurantsModal from './CampaignPromoModal/CampaignRestaurantsModal.view';
import CampaignPromoModal from './CampaignPromoModal/CampaignPromoModal.view';
import CampaignProductsModal from './CampaignPromoModal/CampainProductsModal.view';
import { getALLMenus } from '../../apis/backend';
import { handleRestaurantOpenModal, handlePromoValidate, handleRestaurantsValidate, handleOpenOneShopModal, getCommonProductsBySection } from './CampaignPromo.services';
const CampaignPromoComponent: React.FC<any> = ({ classes, history, shops, marketingData, openErrorModal, nbShops, shopId }) => {
    const [selectedCampaign, setSelectedCampaign] = useState<CampaignItem | null>(null);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openRestaurantModal, setOpenRestaurantModal] = useState<boolean>(false);
    const [selectedShops, setSelectedShops] = useState<string[]>([]);
    const [allMenus, setAllMenu] = useState<any>([]);
    const [sections, setSections] = useState<any>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const isOneShop = nbShops === 1
    const handleCloseModal = () => {
        setOpenRestaurantModal(false);
        setOpenModal(false);
    };
    useEffect(() => {

        const fetchData = async () => {
            try {
                const menus = await getALLMenus();
                setAllMenu(menus);
            } catch (error) {
                console.error('Error fetching menus', error);

            }
        };

        fetchData();
    }, []);
    useEffect(() => {
        const commonSections = getCommonProductsBySection(selectedShops, allMenus);
        setSections(commonSections)
    }, [selectedShops, allMenus]);

    return (
        <div className="p-4">
            <BackButton
                className="p-0"
                onClick={() => history.goBack()}
                title={marketing.campaignPromo.text}
                subtitle={marketing.campaignPromo.description}
            />

            <Grid container spacing={2} className="mt-2">
                {CAMPAIGN_ITEMS.map((item) => {
                    const disabled = marketingData?.[item.id]?.disabled || false;
                    const withoutProductSelection = CAMPAIGN_WITHOUT_PRODUCT_SELECTION.includes(item.id);

                    return (
                        <Grid item xs={12} sm={6} md={3} key={item.id}>
                            <Card className={classes.card} aria-disabled={disabled} onClick={() =>
                                !disabled && (
                                    isOneShop
                                        ? handleOpenOneShopModal(item, setSelectedCampaign, shopId, setSelectedShops, setOpenModal)
                                        : handleRestaurantOpenModal(item, setOpenRestaurantModal, setSelectedCampaign, setSelectedShops)
                                )}>
                                {disabled && (
                                    <div className={classes.disabledItem}>
                                        <Typography variant="body2" className={`${classes.disabledTypo} px-3`}>
                                            Pour activer la fonctionnalité, merci de contacter Dishop
                                        </Typography>
                                    </div>
                                )}

                                <CardMedia component="img" src={item.image} alt={item.title} className={classes.media} />

                                <CardContent className={classes.cardContent}>
                                    <Typography variant="subtitle1" className={classes.title}>
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body2" className={classes.description}>
                                        {item.description}
                                    </Typography>
                                    <Typography variant="body2" className={classes.more} onClick={() =>
                                        !disabled && (
                                            isOneShop
                                                ? handleOpenOneShopModal(item, setSelectedCampaign, shopId, setSelectedShops, setOpenModal)
                                                : handleRestaurantOpenModal(item, setOpenRestaurantModal, setSelectedCampaign, setSelectedShops)
                                        )
                                    }>
                                        EN SAVOIR PLUS <ChevronRight className={classes.leftArrow} />
                                    </Typography>
                                </CardContent>
                            </Card>



                            {selectedCampaign?.id === item.id && openRestaurantModal && (
                                <CampaignRestaurantsModal
                                    classes={classes}
                                    showModal={!!selectedCampaign}
                                    shops={shops}
                                    loading={false}
                                    handleClose={handleCloseModal}
                                    text={SHOPS_MODAL_TEXT}
                                    title={selectedCampaign.title}
                                    onClick={(shopIds) =>
                                        handleRestaurantsValidate(
                                            shopIds,
                                            setSelectedShops,
                                            setOpenModal,
                                            openErrorModal,
                                            setOpenRestaurantModal
                                        )
                                    }
                                    choosedShops={selectedShops}
                                />
                            )}
                            {selectedCampaign?.id === item.id && openModal && (
                                withoutProductSelection ? (
                                    <CampaignPromoModal
                                        classes={classes}
                                        showModal={!!selectedCampaign}
                                        loading={isLoading}
                                        handleClose={() => {
                                            setOpenModal(false);
                                            !isOneShop && setOpenRestaurantModal(true);
                                        }}
                                        selectedCampaign={selectedCampaign}
                                        onClick={(formValues) =>
                                            handlePromoValidate(
                                                formValues,
                                                selectedShops,
                                                setOpenModal,
                                                setOpenRestaurantModal,
                                                openErrorModal,
                                                setIsLoading,
                                                true
                                            )
                                        }
                                        isUpdate={false}
                                    />
                                ) : (
                                    <CampaignProductsModal
                                        classes={classes}
                                        showModal={!!selectedCampaign}
                                        loading={isLoading}
                                        handleClose={() => {
                                            setOpenModal(false);
                                            !isOneShop && setOpenRestaurantModal(true);
                                        }}
                                        selectedCampaign={selectedCampaign}
                                        selectedShops={selectedShops}
                                        allMenus={allMenus}
                                        onClick={(formValues) =>
                                            handlePromoValidate(
                                                formValues,
                                                selectedShops,
                                                setOpenModal,
                                                setOpenRestaurantModal,
                                                openErrorModal,
                                                setIsLoading,
                                                false
                                            )
                                        }
                                        openErrorModal={openErrorModal}
                                        isUpdate={false}
                                        sections={sections}
                                    />
                                )
                            )}
                        </Grid>
                    );
                })}
            </Grid>

        </div>
    );
};

function mapStateToProps({ firebaseRealTime, user }) {
    const { shops = {}, generalConfig = {} } = firebaseRealTime
    const { marketing: marketingData } = generalConfig
    const { shopId, nbShops } = user;
    return { shops, marketingData, nbShops, shopId };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(CampaignPromoComponent)));
